var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFullWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8942 0.841947C3.68385 0.208988 1.18112 2.1788 0.304433 5.24173C-0.572251 8.30422 0.509052 11.2999 2.7194 11.9328C4.92976 12.5658 7.43249 10.596 8.30918 7.53303C9.18586 4.47054 8.10455 1.47491 5.8942 0.841947ZM5.52179 3.71891C5.4695 4.35277 4.91294 4.82431 4.27907 4.77156C3.6452 4.71927 3.17366 4.1627 3.22641 3.52884C3.2787 2.89497 3.83527 2.42343 4.46914 2.47618C5.103 2.52847 5.57454 3.08504 5.52179 3.71891Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8766 3.23459C12.1505 2.74077 10.1966 4.27861 9.51231 6.66993C8.82797 9.06126 9.67191 11.4003 11.398 11.8941C13.1241 12.3884 15.078 10.8501 15.7623 8.45877C16.4467 6.06744 15.6027 3.72841 13.8766 3.23459ZM13.6224 6.00287C13.5701 6.63674 13.0136 7.10828 12.3797 7.05553C11.7458 7.00324 11.2743 6.44667 11.3271 5.8128C11.3798 5.17894 11.9359 4.7074 12.5698 4.76015C13.2037 4.81244 13.6752 5.36901 13.6224 6.00287Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullWhite);
export default __webpack_public_path__ + "static/media/logo-full-white.533e13cb.svg";
export { ForwardRef as ReactComponent };